<template>
  <v-row justify="center">
    <v-chip-group active-class="primary--text" column>
      <v-chip v-for="tag in tags" :key="tag.id" @click="selecionar(tag)">
        {{ tag.nome }}
      </v-chip>
    </v-chip-group>
  </v-row>
</template>

<script>
export default {
  props: {
    tags: { type: Array, default: () => [], require: false },
    tagNova: { type: Object, default: () => null, require: false },
  },
  data: () => ({
    carregando: false,
    caracteresInvalidos: [
      "$",
      "#",
      "@",
      "!",
      "%",
      "&",
      "*",
      "(",
      ")",
      "_",
      "-",
      "+",
      "=",
    ],
  }),
  watch: {
    tagNova(valor) {
      if (valor) {
        this.tags.push(valor);
      }
    },
  },
  methods: {
    open() {
      this.$emit("visivel");
    },
    selecionar(valor) {
      this.$emit("selecionar", valor);
    },
  },
};
</script>

<style lang="scss" scoped>
.contorno {
  margin-top: 10px;
  background-color: transparent;
  box-shadow: none !important;
}
</style>
